var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 20.503C15.459 20.503 19.9219 16.0401 19.9219 10.542C19.9219 5.04394 15.459 0.581055 9.96094 0.581055C4.46289 0.581055 0 5.04394 0 10.542C0 16.0401 4.46289 20.503 9.96094 20.503ZM9.96094 18.8428C5.37109 18.8428 1.66016 15.1319 1.66016 10.542C1.66016 5.95215 5.37109 2.24121 9.96094 2.24121C14.5508 2.24121 18.2617 5.95215 18.2617 10.542C18.2617 15.1319 14.5508 18.8428 9.96094 18.8428Z",
    fill: "#3A78F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85352 11.5967H9.95117C10.332 11.5967 10.6348 11.3038 10.6348 10.9131V4.33106C10.6348 3.9502 10.332 3.65723 9.95117 3.65723C9.57031 3.65723 9.27734 3.9502 9.27734 4.33106V10.2393H4.85352C4.46289 10.2393 4.16992 10.5322 4.16992 10.9131C4.16992 11.3038 4.46289 11.5967 4.85352 11.5967Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2832,
    height: 19.9316,
    fill: "white",
    transform: "translate(0 0.581055)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.fbd833e6a67243bb3fa864cee4f9bcd0.svg";
export { ForwardRef as ReactComponent };